export default function FooterSection() {
  return (
    <footer className="border-t border-[#d4a843]/20 py-10 sm:py-12 px-5 sm:px-6" style={{ background: '#0c0d18' }}>
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/c79b8da1-7d89-4197-bfec-80ebde63b2cd.png"
            alt="靈魂共鳴賽 Logo"
            className="w-8 h-8 object-contain"
          />
          <div>
            <p className="text-[#d4a843] font-bold text-sm tracking-wider">重燃：靈魂共鳴賽</p>
            <p className="text-[#555] text-xs">Soul Resonance Championship</p>
          </div>
        </div>

        <p className="text-[#d4a843] text-xs font-bold tracking-widest text-center font-serif">
          「為隊伍而戰，為回憶奪分！」
        </p>

        <div className="flex items-center gap-4">
          <span className="text-[#444] text-xs">Black Team</span>
          <span className="text-[#d4a843] text-lg font-black font-serif">VS</span>
          <span className="text-[#888] text-xs">White Team</span>
        </div>
      </div>
      <div className="text-center mt-5 pt-5 border-t border-[#1e2035]">
        <p className="text-[#444] text-xs">© 2026 重燃：靈魂共鳴賽 · 這不是出遊，是一場為友誼而戰的冒險</p>
      </div>
    </footer>
  );
}
